import { render, staticRenderFns } from "./PageOpenApp.vue?vue&type=template&id=1c2e7b0e&"
import script from "./PageOpenApp.vue?vue&type=script&lang=js&"
export * from "./PageOpenApp.vue?vue&type=script&lang=js&"
import style0 from "./PageOpenApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports